import { render, staticRenderFns } from "./uploadsPDF.vue?vue&type=template&id=15a4ed1c"
import script from "./uploadsPDF.vue?vue&type=script&lang=js"
export * from "./uploadsPDF.vue?vue&type=script&lang=js"
import style0 from "./uploadsPDF.vue?vue&type=style&index=0&id=15a4ed1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports